import React, { useState } from 'react';
import SupportTicketList from '../components/SupportTicketList';
import SupportTicketForm from '../components/SupportTicketForm';
import SupportTicketDetail from '../components/SupportTicketDetail';
import TelegramSupport from '../components/TelegramSupport';
import TelegramAdminPanel from '../components/TelegramAdminPanel';
import { useAuth } from '../context/AuthContext';
import { Toaster } from 'react-hot-toast';
import { MessageCircle, Ticket } from 'lucide-react';

import HeaderWithIcon from '../components/common/HeaderWithIcon';

const Support = () => {
  const { user } = useAuth();
  const [currentView, setCurrentView] = useState('list'); // 'list', 'create', 'detail'
  const [activeTab, setActiveTab] = useState('telegram'); // 'telegram', 'tickets' - default to telegram for admins
  const [selectedTicket, setSelectedTicket] = useState(null);

  // Check if user is admin (roleId === 1)
  const isAdmin = user?.roleId === 1;

  const handleCreateNew = () => {
    setCurrentView('create');
  };

  const handleTicketCreated = (ticket) => {
    setCurrentView('list');
    // Optionally show the newly created ticket
    setSelectedTicket(ticket);
    setCurrentView('detail');
  };

  const handleTicketSelect = (ticket) => {
    setSelectedTicket(ticket);
    setCurrentView('detail');
  };

  const handleClose = () => {
    setCurrentView('list');
    setSelectedTicket(null);
  };

  const handleUpdate = () => {
    // This will trigger a refresh of the ticket list
    setCurrentView('list');
  };

  return (
    <div className="min-h-screen relative overflow-hidden">
        <HeaderWithIcon title="Support" />
        {/* Telegram Support Floating Button - Only for non-admins */}
        {!isAdmin && <TelegramSupport position="bottom-right" />}
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#4aed88',
                secondary: '#fff',
              },
            },
            error: {
              duration: 4000,
              iconTheme: {
                primary: '#ff6b6b',
                secondary: '#fff',
              },
            },
          }}
        />

      {/* Admin Tabs - Only visible to admins */}
      {isAdmin && currentView === 'list' && (
        <div className="px-4 mb-4">
          <div className="flex bg-gray-100 rounded-lg p-1">
            <button
              onClick={() => setActiveTab('telegram')}
              className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-md text-sm font-medium transition-all ${
                activeTab === 'telegram'
                  ? 'bg-white text-blue-600 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <MessageCircle className="w-5 h-5" />
              <span>Telegram</span>
            </button>
            <button
              onClick={() => setActiveTab('tickets')}
              className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-md text-sm font-medium transition-all ${
                activeTab === 'tickets'
                  ? 'bg-white text-blue-600 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <Ticket className="w-5 h-5" />
              <span>Tickets</span>
            </button>
          </div>
        </div>
      )}

      {/* Admin Content based on active tab */}
      {isAdmin && currentView === 'list' && activeTab === 'telegram' && (
        <div className="px-4">
          <TelegramAdminPanel />
        </div>
      )}

      {/* Tickets view - shown for non-admins always, or for admins when tickets tab is active */}
      {currentView === 'list' && (!isAdmin || activeTab === 'tickets') && (
        <SupportTicketList 
          onCreateNew={handleCreateNew}
          onTicketSelect={handleTicketSelect}
        />
      )}
      
      {currentView === 'create' && (
        <SupportTicketForm 
          onTicketCreated={handleTicketCreated}
          onClose={handleClose}
        />
      )}
      
      {currentView === 'detail' && (
        <SupportTicketDetail 
          ticket={selectedTicket}
          onClose={handleClose}
          onUpdate={handleUpdate}
        />
      )}
    </div>
  );
};

export default Support;